import { createContext, useReducer } from 'react';

export const GlobalStateContext = createContext();

const globalStateReducer = (state, action) => {
  return { ...state, [action.key]: action.value };
};

export const GlobalStateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalStateReducer, {
    // 초기값
    payConfig: undefined,
  });

  return (
    <GlobalStateContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalStateContext.Provider>
  );
};
